import 'css-chunksrc/client/scenes/workloads/wbs/task/allocationsList/details/allocation/completionCheck/styles.scss';export default {
  "taskCompletionStatus": "_taskCompletionStatus_1mhg7_1",
  "late": "_late_1mhg7_11",
  "progressed": "_progressed_1mhg7_15",
  "completed": "_completed_1mhg7_19",
  "disabled": "_disabled_1mhg7_36",
  "constrained": "_constrained_1mhg7_47"
};